// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"96":"vendors","792":"main"}[chunkId] + "." + {"96":"61f9f9bd5c6656cd4373","792":"ce8a7d172583db367fb7"}[chunkId] + ".css";
};